import { useState, useEffect } from 'react';
import client from '../api/client';
import { useAuthStore } from '../store/authStore';
import { isPetLeadFlow, trackFunnelStep } from '../utils/analytics';

function VerifyEmailPage() {
  const { user } = useAuthStore();
  const email =
    user?.email || sessionStorage.getItem('pendingVerificationEmail') || '';

  const [status, setStatus] = useState<string>('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isPetLeadFlow()) {
      trackFunnelStep('verify_email_view');
    }
  }, []);

  const handleResend = async () => {
    if (!email) {
      setStatus('No email found for verification. Please register again.');
      return;
    }
    setStatus('');
    setLoading(true);
    try {
      await client.post('/auth/verify-email/resend', { email });
      setStatus('Verification email sent. Check your inbox.');
      sessionStorage.setItem('pendingVerificationEmail', email);
    } catch (err: any) {
      setStatus(err.response?.data?.error || 'Failed to send email.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container" style={{ maxWidth: '700px', margin: '0 auto' }}>
      <div className="card">
        <div className="card-header">Verify your email</div>
        <div style={{ padding: '1rem' }}>
          <p style={{ marginTop: 0 }}>
            We’ve sent a verification link to your email. Please click the link to verify your account.
          </p>

          <div className="form-group" style={{ marginTop: '1rem' }}>
            <label htmlFor="email">Email</label>
            <input id="email" type="email" value={email} readOnly disabled />
          </div>

          {status && (
            <div
              className={
                status.toLowerCase().startsWith('failed')
                  ? 'alert alert-error'
                  : 'alert alert-success'
              }
              style={{ marginTop: '1rem' }}
            >
              {status}
            </div>
          )}

          <button
            className="btn btn-primary"
            onClick={handleResend}
            disabled={loading}
            style={{ marginTop: '1rem' }}
          >
            {loading ? 'Sending...' : 'Resend verification email'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default VerifyEmailPage;

